import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';
import { CustomerSourceTypesState } from './types';

const selectCustomerSourceTypesReducer = (state: RootState): CustomerSourceTypesState => state.customerSourceTypes;

export const selectCustomerSourceTypesIsEmpty = createSelector(
  [selectCustomerSourceTypesReducer],
  (customerSourceTypes) => customerSourceTypes.customerSourceTypesIsEmpty
);

export const selectCustomerSourceTypesLoading = createSelector(
  [selectCustomerSourceTypesReducer],
  (customerSourceTypes) => customerSourceTypes.customerSourceTypesLoading
);

export const selectCustomerSourceTypes = createSelector(
  [selectCustomerSourceTypesReducer],
  (customerSourceTypes) => customerSourceTypes.customerSourceTypes
);
